import moment from "moment";

export class DateUtils {
  static formatDate(data: any, format: string = 'MMMM D, YYYY') {
    return data && !['', '0000-00-00 00:00:00', '1970-01-01 00:00:00', '0001-01-01T00:00:00'].includes(data) ?
      moment.utc(data).isValid() ? moment.utc(data).local().format(format) : '--' : '--';
  }

  static formatDateTime(data: any) {
    return data && !['', '0000-00-00 00:00:00', '1970-01-01 00:00:00', '0001-01-01T00:00:00'].includes(data) ?
      moment.utc(data).isValid() ? moment.utc(data).local().format('MMMM D, YYYY h:mm:ss A') : '--' : '--';
  }
}
